import { buildModelManager } from "../builder.js";
const DefaultMessageSkeletonSelection = {
  __typename: true,
  id: true,
  audioLink: true,
  body: true,
  bodyParameters: true,
  buttonTitle: true,
  campaignId: true,
  createdAt: true,
  customerId: true,
  documentLink: true,
  documentName: true,
  flowNodeId: true,
  footer: true,
  header: true,
  imageLink: true,
  isCampaignTrigger: true,
  isUrlButtonAtBottom: true,
  redirectionUrlId: true,
  shopifyUpsellLineItems: true,
  sourceWhatsappRuleId: true,
  stickerLink: true,
  triggeredWhatsappRuleId: true,
  updatedAt: true,
  urlButtonLink: true,
  urlButtonLink2: true,
  urlButtonText: true,
  urlButtonText2: true,
  urlClicks: true,
  videoLink: true,
  whatsappTemplateId: true
};
const modelApiIdentifier = "messageSkeleton";
const pluralModelApiIdentifier = "messageSkeletons";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMessageSkeletonSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMessageSkeletonSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMessageSkeletonSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMessageSkeletonSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMessageSkeletonSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMessageSkeletonSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMessageSkeletonSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createMessageSkeleton",
    operationReturnType: "CreateMessageSkeleton",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      messageSkeleton: { required: false, type: "CreateMessageSkeletonInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMessageSkeletonSelection
  },
  {
    type: "action",
    operationName: "bulkCreateMessageSkeletons",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateMessageSkeletonsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMessageSkeletonSelection
  },
  {
    type: "action",
    operationName: "updateMessageSkeleton",
    operationReturnType: "UpdateMessageSkeleton",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      messageSkeleton: { required: false, type: "UpdateMessageSkeletonInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMessageSkeletonSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateMessageSkeletons",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateMessageSkeletonsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMessageSkeletonSelection
  },
  {
    type: "action",
    operationName: "deleteMessageSkeleton",
    operationReturnType: "DeleteMessageSkeleton",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteMessageSkeletons",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertMessageSkeleton",
    operationReturnType: "UpsertMessageSkeleton",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      messageSkeleton: { required: false, type: "UpsertMessageSkeletonInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateMessageSkeletonResult": { hasReturnType: false },
      "... on UpdateMessageSkeletonResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMessageSkeletonSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertMessageSkeletons",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertMessageSkeletonsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultMessageSkeletonSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "messageSkeletonGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MessageSkeletonManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMessageSkeletonSelection,
  operations
);
export {
  DefaultMessageSkeletonSelection,
  MessageSkeletonManager
};
//# sourceMappingURL=MessageSkeleton.js.map
